import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaPrint, FaPlus, FaSyncAlt, FaEye, FaEdit, FaTrash, FaTimes,  FaFilter, FaSearch, FaStore, FaCalendarAlt, FaCheck, FaUsers, FaMapMarkerAlt, FaBirthdayCake, FaUser, FaGraduationCap,  FaBuilding, FaEnvelope, FaPhone} from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import backgroundkartu from "../../assets/images/kartu1.png";
import backgroundkartu2 from "../../assets/images/kartu2.png";
import FilterModal from "./FilterModel";
import axios from "axios";

const KaryawanPage = () => {
  const navigate = useNavigate();
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}/v1/employee`;
  const token = localStorage.getItem("token");
  const [totalKaryawan, setTotalKaryawan] = useState(0); 
  const [karyawanList, setKaryawanList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOption, setFilterOption] = useState("default");
  const [selectedKaryawan, setSelectedKaryawan] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedKaryawanToDelete, setSelectedKaryawanToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(5); // Jumlah data per halaman
  const [page, setPage] = useState(1); // Halaman saat ini
  const [totalPages, setTotalPages] = useState(1); // Total halaman
  const [isFilterShiftOpen, setFilterShiftOpen] = useState(false);
  const [currentKaryawan, setCurrentKaryawan] = useState([]);
  const [outletId, setOutletId] = useState(1);
  const [periodId, setPeriodId] = useState(1);
  const [shiftData, setShiftData] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filters, setFilters] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [showCardModal, setShowCardModal] = useState(false);
  const [outletData, setOutletData] = useState(null);

  
  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
    setIsFilterOpen(false);
    fetchKaryawan(appliedFilters); // Fetch data sesuai filter
  };

  const fetchKaryawan = async (appliedFilters = {}) => {
    setIsLoading(true);
  
    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      if (!token) {
        console.error("Token tidak ditemukan. Silakan login ulang.");
        return;
      }
  
      const params = new URLSearchParams({
        per_page: appliedFilters.per_page || perPage,
        page: appliedFilters.page || currentPage,
        order_by: appliedFilters.order_by || "created_at",
        status: appliedFilters.status || "all",
        search: appliedFilters.search || globalFilter, // Tambahkan search
      }).toString();
  
      console.log("Request Params:", params);
  
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee?${params}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      console.log("Full Response:", response);
      console.log("Response Data:", response.data);
  
      if (response.data.success) {
        const karyawanData = response.data.data || [];
        const totalData = response.data.meta.total 
        const lastPage = response.data.meta?.last_page || 1;
  
        setCurrentKaryawan(karyawanData);
        setTotalKaryawan(totalData);
  
        console.log("Total Data:", totalData);
        console.log("Last Page:", lastPage);
  
        setTotalPages(lastPage);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      if (error.response) {
        console.error("Error Response:", error.response);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const fetchOutletDetail = async (outletId) => {
    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      if (!token) {
        console.error("Token tidak ditemukan. Silakan login ulang.");
        return;
      }
  
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/outlet/${outletId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      if (response.data.success) {
        setOutletData(response.data.data);  // Menyimpan data outlet ke state
      }
    } catch (error) {
      console.error("Failed to fetch outlet data:", error);
    }
  };
  useEffect(() => {
    if (selectedKaryawan?.outlet?.id) {
      fetchOutletDetail(selectedKaryawan.outlet.id);  // Memanggil API outlet detail dengan ID
    }
  }, [selectedKaryawan]);  // Menjalankan setiap kali selectedKaryawan berubah
    

  // Fungsi untuk pagination
  const paginate = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return; // Cek jika halaman valid
    setCurrentPage(pageNumber);
    fetchKaryawan({ page: pageNumber }); // Ambil data berdasarkan halaman yang dipilih
  };
  
  const fetchShiftData = async () => {
    if (!token) {
      console.error("Token tidak ditemukan!");
      return;
    }
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/employee/shift?outlet_id=${outletId}&period_id=${periodId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Gagal mengambil data shift");
      }
  
      const data = await response.json();
  
      // 🚀 Update currentKaryawan agar langsung muncul di tabel
      setCurrentKaryawan(data.data);
  
      // Tutup form filter setelah diterapkan
      setFilterShiftOpen(false);
    } catch (error) {
      console.error("Gagal mengambil data shift:", error.message);
    }
  };
  
  const fetchOutlets = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Gagal mengambil data outlet");
  
      const data = await response.json();
      setOutlets(data.data);
    } catch (error) {
      console.error("Error fetching outlets:", error.message);
    }
  };
  
  const fetchPeriods = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/shift/period-shift`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Gagal mengambil data periode shift");
  
      const data = await response.json();
      setPeriods(data.data);
    } catch (error) {
      console.error("Error fetching period shifts:", error.message);
    }
  };
  
  useEffect(() => {
    fetchKaryawan({ search: globalFilter });
    fetchOutlets();
    fetchPeriods();
  }, [globalFilter]);

  // Fungsi untuk menangani pencarian
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };


  // Fungsi untuk menampilkan detail karyawan
  const handleView = (karyawan) => {
    setSelectedKaryawan(karyawan);
  };

  // Fungsi untuk menutup panel detail
  const handleCloseDetail = () => {
    setSelectedKaryawan(null);
  };

  // Fungsi untuk navigasi ke halaman edit karyawan
  const handleEdit = (id) => {
    navigate(`/enterprise/karyawan/editkaryawan/${id}`);
  };

  // Fungsi untuk membuka modal konfirmasi hapus
  const handleDelete = (karyawan) => {
    setSelectedKaryawanToDelete(karyawan);
    setDeleteModalOpen(true);
  };

  // Fungsi untuk mengonfirmasi penghapusan
  const confirmDelete = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee/delete/${selectedKaryawanToDelete.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Gagal menghapus karyawan");
      }
  
      // Update list, tutup modal, dan notif sukses
      setKaryawanList((prevList) =>
        prevList.filter((k) => k.id !== selectedKaryawanToDelete.id)
      );
      setDeleteModalOpen(false);
      setSelectedKaryawanToDelete(null);
  
      alert(`Karyawan "${selectedKaryawanToDelete.full_name}" berhasil dihapus.`);
    } catch (error) {
      console.error("Error saat menghapus karyawan:", error);
      alert(`Gagal menghapus karyawan: ${error.message}`);
    }
  };
  

  // Fungsi untuk menutup modal
  const closeModal = () => {
    setDeleteModalOpen(false);
    setSelectedKaryawanToDelete(null);
  };

 return (
 <div className=" p-5 min-h-screen flex flex-col space-y-6">
{/* <div className="p-5 bg-gray-50 min-h-screen flex flex-col gap-5"> */}

      {/* ============================
          HEADER STYLE (MATCH OUTLET)
      ============================ */}
      <div className="bg-white shadow-lg rounded-2xl p-5 border border-gray-100">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-green-100 rounded-2xl shadow-inner">
            <FaUsers className="text-green-600" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-800">Karyawan</h1>
            <p className="text-gray-500 text-sm"> Menampilkan semua data Karywan yang terdaftar pada Outlet masing-masing</p>
          </div>
        </div>

        {/* BREADCRUMB */}
        <nav aria-label="Breadcrumb" className="mt-3 text-gray-500 text-sm">
          <ol className="flex items-center space-x-2">
            <li>
              <button
                onClick={() => navigate("/")}
                className="hover:text-gray-700 transition"
              >
                Enterprise
              </button>
            </li>
            <li>/</li>
            <li className="text-gray-400">Karyawan</li>
          </ol>
        </nav>
      </div>


      {/* ========================================== */}
      {/* PANEL ISI: BUTTON TAMBAH + SHIFT + FILTER + TABEL */}
      {/* ========================================== */}
      <div className={`${selectedKaryawan ? "flex gap-5 items-start" : ""} mt-5`}>

      <div className="bg-white shadow-xl rounded-2xl p-6 flex-1 min-w-[65%]">

        {/* Tombol Aksi + Search + Filter */}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-6">

          {/* Tombol Tambah + Shift */}
          <div className="flex space-x-3">

            <button
              className="p-3 px-5 bg-yellow-400 text-white rounded-xl shadow-md flex items-center gap-2
              hover:bg-yellow-700 hover:scale-105 transition"
              onClick={() => navigate("/enterprise/karyawan/createkaryawan")}
            >
              <FaPlus /> Tambah
            </button>

            <button
              className="p-3 px-5 bg-blue-500 text-white rounded-xl shadow-md flex items-center gap-2
              hover:bg-blue-600 hover:scale-105 transition"
              onClick={() => navigate("/enterprise/karyawan/shiftingkaryawan")}
            >
              <FaSyncAlt /> Shift
            </button>

          </div>

          {/* Search + Filter */}
          <div className="flex items-center gap-3 w-full md:w-auto">

            {/* Search */}
            <div className="relative flex-1 w-full md:w-64">
              <input
                type="text"
                placeholder="Cari karyawan..."
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-xl shadow-sm
                focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <FaSearch className="absolute left-3 top-2.5 text-gray-400" />
            </div>

            {/* Filter */}
            <button
              onClick={() => setIsFilterOpen(true)}
              className="p-3 px-4 bg-white border border-gray-300 rounded-xl shadow 
              hover:bg-gray-100 hover:scale-105 flex items-center gap-2 transition"
            >
              <FaFilter className="text-blue-500" /> Filter
            </button>

          </div>
        </div>


        {/* ========================================== */}
        {/* TABEL KARYAWAN */}
        {/* ========================================== */}
        <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm">
              <table className="min-w-full bg-white rounded-2xl">
                <thead className="bg-green-50">
              <tr>
                <th className="p-4 text-left font-semibold text-gray-700 border-b rounded-tl-xl">No</th>
                <th className="p-4 text-left font-semibold text-gray-700 border-b">Nama</th>
                <th className="p-4 text-left font-semibold text-gray-700 border-b">Gender</th>
                <th className="p-4 text-left font-semibold text-gray-700 border-b">Pendidikan</th>
                <th className="p-4 text-left font-semibold text-gray-700 border-b">Usia</th>
                <th className="p-4 text-left font-semibold text-gray-700 border-b">Outlet</th>
                <th className="p-4 text-left font-semibold text-gray-700 border-b rounded-tr-xl">Aksi</th>
              </tr>
            </thead>

            <tbody>
              {currentKaryawan.slice(0, perPage).map((karyawan, index) => (
                <tr
                  key={karyawan.id}
                  className="hover:bg-gray-50 border-t border-gray-200"
                >
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{karyawan.full_name}</td>
                  <td className="px-4 py-2">
                    {karyawan.gender === "male" ? "Laki-laki" : "Perempuan"}
                  </td>
                  <td className="px-4 py-2">{karyawan.pendidikan}</td>
                  <td className="px-4 py-2">
                    {new Date().getFullYear() -
                      new Date(karyawan.tanggal_lahir).getFullYear()}
                  </td>
                  <td className="px-4 py-2">{karyawan.outlet?.name || "-"}</td>

                  {/* Tombol Aksi Premium */}
                  <td className="px-4 py-2 flex gap-2">

                    <button
                      className="p-2 bg-green-100 hover:bg-green-200 rounded-lg shadow-md
                      text-green-600 hover:text-green-700 transition transform hover:scale-110"
                      onClick={() => handleView(karyawan)}
                      title="Detail"
                    >
                      <FaEye />
                    </button>

                    <button
                      className="p-2 bg-blue-100 hover:bg-blue-200 rounded-lg shadow-md
                      text-blue-600 hover:text-blue-700 transition transform hover:scale-110"
                      onClick={() => handleEdit(karyawan.id)}
                      title="Edit"
                    >
                      <FaEdit />
                    </button>

                    <button
                      className="p-2 bg-red-100 hover:bg-red-200 rounded-lg shadow-md
                      text-red-600 hover:text-red-700 transition transform hover:scale-110"
                      onClick={() => handleDelete(karyawan)}
                      title="Hapus"
                    >
                      <FaTrash />
                    </button>

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>


        {/* Pagination */}
        <div className="flex justify-between items-center mt-6">

          <p className="text-sm text-gray-500">
            Menampilkan {currentKaryawan.length} dari total {totalKaryawan} karyawan
          </p>

          <div className="flex items-center space-x-2">

            <button
              className="flex items-center px-3 py-1.5 bg-green-100 hover:bg-green-200 text-gray-700 rounded-xl shadow-sm transition disabled:opacity-50 active:scale-95"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage <= 1}
            >
              <FiChevronLeft /> Prev
            </button>

            <span className="text-sm text-gray-600">
              Halaman <strong>{currentPage}</strong> dari{" "}
              <strong>{totalPages}</strong>
            </span>

            <button
              className="flex items-center px-3 py-1.5 bg-green-100 hover:bg-green-200 text-gray-700 rounded-xl shadow-sm transition disabled:opacity-50 active:scale-95"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              Next <FiChevronRight />
            </button>

          </div>
        </div>

      </div>

    
  {isFilterShiftOpen && (
  <div className="bg-white p-6 rounded-2xl shadow-md mb-4 border border-gray-100">
    <div className="flex items-center gap-2 mb-4 text-yellow-600">
      <FaFilter className="text-lg" />
      <h2 className="text-lg font-semibold">Filter Shift Karyawan</h2>
    </div>

    <div className="flex flex-col md:flex-row gap-4">
      {/* ComboBox untuk Outlet */}
      <div className="flex items-center w-full md:w-1/2">
        <FaStore className="text-gray-400 mr-2" />
        <select
          value={outletId}
          onChange={(e) => setOutletId(e.target.value)}
          className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400"
        >
          <option value="">Pilih Outlet</option>
          {outlets.map((outlet) => (
            <option key={outlet.id} value={outlet.id}>
              {outlet.name}
            </option>
          ))}
        </select>
      </div>

      {/* ComboBox untuk Periode Shift */}
      <div className="flex items-center w-full md:w-1/2">
        <FaCalendarAlt className="text-gray-400 mr-2" />
        <select
          value={periodId}
          onChange={(e) => setPeriodId(e.target.value)}
          className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400"
        >
          <option value="">Pilih Periode Shift</option>
          {periods.map((period) => (
            <option key={period.id} value={period.id}>
              {period.year} - {period.month}
            </option>
          ))}
        </select>
      </div>

      {/* Tombol Apply */}
      <button
        className="flex items-center justify-center gap-2 bg-green-500 text-white px-6 py-2 rounded-xl hover:bg-green-600 transition-all duration-200 shadow-sm mt-1 md:mt-0"
        onClick={fetchShiftData}
      >
        <FaCheck />
        Terapkan
      </button>
    </div>
  </div>
)}

{shiftData.length > 0 && (
  <div className="bg-white rounded-2xl shadow-md p-6 mb-4 border border-gray-100">
    <div className="flex items-center gap-2 mb-4 text-blue-600">
      <FaUsers className="text-lg" />
      <h2 className="text-lg font-semibold">Data Shift Karyawan</h2>
    </div>

    <div className="overflow-x-auto rounded-lg">
      <table className="min-w-full text-left text-sm text-gray-700">
        <thead className="bg-gray-50 text-gray-600">
          <tr>
            <th className="px-5 py-3 border-b border-gray-200 flex items-center gap-2">
              <FaUsers className="text-gray-400" />
              Nama
            </th>
            <th className="px-5 py-3 border-b border-gray-200 flex items-center gap-2">
              <FaMapMarkerAlt className="text-gray-400" />
              Outlet
            </th>
            <th className="px-5 py-3 border-b border-gray-200 flex items-center gap-2">
              <FaBirthdayCake className="text-gray-400" />
              Usia
            </th>
          </tr>
        </thead>
        <tbody>
          {shiftData.map((karyawan) => (
            <tr
              key={karyawan.id}
              className="hover:bg-gray-50 transition duration-150"
            >
              <td className="px-5 py-3 border-b border-gray-100">{karyawan.full_name}</td>
              <td className="px-5 py-3 border-b border-gray-100">{karyawan.outlet?.name}</td>
              <td className="px-5 py-3 border-b border-gray-100">
                {new Date().getFullYear() -
                  new Date(karyawan.tanggal_lahir).getFullYear()}{" "}
                tahun
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}
{selectedKaryawan && (
  <div className="relative w-96 bg-white rounded-2xl shadow-lg p-6 ml-4">

    {/* Tombol Close */}
    <button
      className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
      onClick={handleCloseDetail}
    >
      <FaTimes size={20} />
    </button>

    {/* Foto & Basic Info */}
    <div className="flex flex-col items-center mt-6">
      <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center text-gray-500 text-3xl mb-3">
        <FaUser />
      </div>
      <h2 className="text-xl font-bold">{selectedKaryawan.full_name}</h2>
      <p className="text-sm text-gray-500 mb-2">
        {new Date().getFullYear() - new Date(selectedKaryawan.tanggal_lahir).getFullYear()} Tahun
      </p>
    </div>

    {/* Detail Info */}
    <div className="mt-5 space-y-3 text-sm text-gray-700">
      <p className="flex items-center gap-2">
        <FaCalendarAlt className="text-gray-400" />
        <span className="font-medium">TTL:</span> {selectedKaryawan.tempat_lahir}, {selectedKaryawan.tanggal_lahir}
      </p>
      <p className="flex items-center gap-2">
        <FaGraduationCap className="text-gray-400" />
        <span className="font-medium">Pendidikan:</span> {selectedKaryawan.pendidikan}
      </p>
      <p className="flex items-center gap-2">
        <FaBuilding className="text-gray-400" />
        <span className="font-medium">Penempatan:</span> {selectedKaryawan.outlet?.name}
      </p>
      <p className="flex items-center gap-2">
        <FaEnvelope className="text-gray-400" />
        <span className="font-medium">Email:</span> {selectedKaryawan.email}
      </p>
      <p className="flex items-center gap-2">
        <FaPhone className="text-gray-400" />
        <span className="font-medium">No. HP:</span> {selectedKaryawan.no_hp}
      </p>
      <p className="flex items-start gap-2">
        <FaMapMarkerAlt className="text-gray-400 mt-1" />
        <span className="font-medium">Alamat:</span> {selectedKaryawan.alamat}
      </p>
    </div>

    {/* Tombol Cetak */}
    <div className="mt-6 flex justify-end">
      <button
        onClick={() => setShowCardModal(true)}
        className="bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition flex items-center gap-2"
      >
        <FaPrint /> Cetak Kartu
      </button>
    </div>

  </div>
)}

 </div>
{/* Modal Cetak Kartu */}
{showCardModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
    <div className="bg-white rounded-lg shadow-lg p-6 relative" id="print-area">
      <button
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        onClick={() => setShowCardModal(false)}
      >
        <FaTimes size={20} />
      </button>

      {/* Kartu Karyawan (Depan) */}
      <div
        className="p-6 rounded-xl shadow-md w-[245px] h-[396px] bg-white bg-cover bg-center relative text-center"
        style={{ backgroundImage: `url(${backgroundkartu})` }}
      >
        <div className="font-bold text-2xl text-gray-800"><span className="font-normal">DJAYA</span> <span className="font-bold">MEDICA</span></div>

        <div className="flex justify-center my-4">
          <div className="w-24 h-24 bg-gray-300 rounded-full flex items-center justify-center text-5xl text-white">
            <FaUser />
          </div>
        </div>

        <h3 className="text-lg font-semibold">{selectedKaryawan.full_name}</h3>
        {/* <p className="text-sm font-medium text-gray-500">EMP#{selectedKaryawan.employee_number || '000000'}</p> */}
        <p className="text-sm font-medium text-gray-700 mt-1 capitalize">
          {selectedKaryawan.role || 'Karyawan'} <br />
          Djaya Medica {selectedKaryawan.outlet?.name ? `Outlet ${selectedKaryawan.outlet.name}` : ''}
        </p>

        <div className="mt-6 border-t pt-4 text-xs text-gray-600">
          <p><strong>2025 Djaya Medica</strong></p>
          <p className="mt-1">{outletData.address}</p>
          <p>{outletData.phone}</p>
          <p>{outletData.email}</p>
        </div>
      </div>

      {/* Kartu Karyawan (Belakang) */}
      <div
        className="p-6 rounded-xl shadow-md w-[245px] h-[396px] bg-white bg-cover bg-center relative text-center mt-6"
        style={{ backgroundImage: `url(${backgroundkartu2})` }}
      >
        <div className="font-normal text-2xl text-gray-800">
    <span className="font-normal">DJAYA</span> <span className="font-bold">MEDICA</span>
  </div>
  
  <div className="mt-2 text-lg font-medium text-gray-700">
    Sehat Bersama Djaya Medica
  </div>
        <div className="mt-6 text-sm text-gray-600">
          <p><strong>Syarat & Ketentuan:</strong></p>
          <p className="mt-2">Karyawan diharuskan menggunakan kartu karyawan saat bekerja.</p>
        </div>
      </div>


      {/* Tombol Print */}
      <div className="mt-6 flex justify-end">
        <button
          onClick={() => {
            const printContents = document.getElementById('print-area').innerHTML;
            const originalContents = document.body.innerHTML;
            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
            window.location.reload(); // reload biar UI balik normal
          }}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Print
        </button>
      </div>
    </div>
  </div>
)}


{isDeleteModalOpen && (
  <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded-2xl shadow-xl max-w-sm w-full text-center">
      <h2 className="text-xl font-bold text-red-600 mb-2">Hapus Karyawan?</h2>
      <p className="text-sm text-gray-700">
        Apakah kamu yakin ingin menghapus <span className="font-semibold">{selectedKaryawanToDelete.full_name}</span>?
      </p>
      <div className="flex justify-center gap-4 mt-6">
        <button
          className="bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-lg font-medium shadow-sm"
          onClick={confirmDelete}
        >
          Hapus
        </button>
        <button
          className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-5 py-2 rounded-lg font-medium shadow-sm"
          onClick={closeModal}
        >
          Batal
        </button>
      </div>
    </div>
  </div>
)}

      <FilterModal
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        onApply={handleApplyFilters}
      />
    </div>
    
   
  );
};

export default KaryawanPage;